// @flow

import { type Country } from '@tectonics/prs/country';

const NOT_NUMBERS = /[^0-9]+/ug;

export function getZipcodeNormalizer(country: Country): ?string => string {

  return (zipcode: ?string) => {

    if (!zipcode)
      return '';

    const onlyNumbersZipcode = zipcode.replace(NOT_NUMBERS, '');

    switch (country) {
      case 'br':
      case 'gh':
        return onlyNumbersZipcode.substr(0, 8);

      case 'mx':
      case 'pe':
      case 'bo':
      case 'cr':
      case 'py':
      case 'pa':
      case 'do':
      case 'sv':
      case 'gt':
      case 'eg':
      case 'jm':
      case 'tr':
        return onlyNumbersZipcode.substr(0, 5);

      case 'ar':
        return onlyNumbersZipcode.substr(0, 4);

      case 'co':
      case 'uy':
        return onlyNumbersZipcode.substr(0, 6);

      case 'cl':
      case 'ec':
        return onlyNumbersZipcode.substr(0, 7);

      case 'za':
        return onlyNumbersZipcode.substr(0, 7);

      case 'ke':
      case 'tz':
      case 'ug':
        return onlyNumbersZipcode.substr(0, 9);

      case 'ng':
      case 'zm':
        return onlyNumbersZipcode.substr(0, 6);

      case 'in':
      case 'ph':
        return onlyNumbersZipcode.substr(0, 6);

      case 'id':
        return onlyNumbersZipcode.substr(0, 5);

      default:
        throw new Error(`ZipcodeNormalizer: not implemented for country ${country}`);
    }
  };
}
